import React, { HTMLAttributeAnchorTarget } from 'react'
import classNames from 'classnames'

interface Props {
  className?: string
  label: string
  link: string
  target?: HTMLAttributeAnchorTarget
}

const AppLink: React.FC<Props> = ({
  className,
  label,
  link,
  target = '_self',
}) => {
  return (
    <a
      className={classNames('app-link', { [className || '']: !!className })}
      href={link}
      target={target}
    >
      {label}
    </a>
  )
}

export default AppLink
